window.SMTX.Transcription = (function () {
  if ($('.translation-quote-page').length < 1) {
    return false;
  }

  var max_words_for_translation = 4000;

  // setTimeout(function(){
  //    // test email
  //   $('input[name="first_name"]').val('Test');
  //   $('input[name="last_name"]').val('Testsson');
  //   $('input[name="email"]').val('testar@semantix.com');
  //   $('input[name="company"]').val('Company A');
  //   $('input[name="phone"]').val('+46701234567').trigger('change');
  // }, 50);

  var employeesOptions = [
    { value: '2-50', text: '2-50' },
    { value: '51-250', text: '51-250' },
    { value: '251-500', text: '251-500' },
    { value: '501-1000', text: '501-1000' },
    { value: '1001-5000', text: '1001-5000' },
    { value: '5000+', text: '5000+' },
  ];
  
  var _validLangsForTranslation = [
    { semantixId: '209', isoCode: 'sv-SE', name: 'Swedish' },
    { semantixId: '322', isoCode: 'sv-FI', name: 'Swedish' },
    { semantixId: '50', isoCode: 'da-DK', name: 'Danish' },
    { semantixId: '76', isoCode: 'fi-FI', name: 'Finnish' },
    { semantixId: '148', isoCode: 'nb-NO', name: 'Norwegian' },
    { semantixId: '301', isoCode: 'nn-NO', name: 'Norwegian' },
    { semantixId: '68', isoCode: 'en-US', name: 'English' },
    { semantixId: '69', isoCode: 'en-GB', name: 'English' },
    { semantixId: '277', isoCode: 'en-AU', name: 'English' },
    { semantixId: '278', isoCode: 'en-NZ', name: 'English' },
    { semantixId: '344', isoCode: 'en-CA', name: 'English' },
    { semantixId: '345', isoCode: 'en-ZA', name: 'English' },
    { semantixId: '81', isoCode: 'fr-FR', name: 'French' },
    { semantixId: '281', isoCode: 'fr-BE', name: 'French' },
    { semantixId: '282', isoCode: 'fr-CA', name: 'French' },
    { semantixId: '283', isoCode: 'fr-CH', name: 'French' },
    { semantixId: '408', isoCode: 'fr-LU', name: 'French' },
    { semantixId: '202', isoCode: 'es-ES', name: 'Spanish' },
    { semantixId: '184', isoCode: 'es-AR', name: 'Spanish' },
    { semantixId: '186', isoCode: 'es-CL', name: 'Spanish' },
    { semantixId: '378', isoCode: 'es-CO', name: 'Spanish' },
    { semantixId: '366', isoCode: 'es-ES', name: 'Spanish' },
    { semantixId: '196', isoCode: 'es-MX', name: 'Spanish' },
    { semantixId: '387', isoCode: 'es-PR', name: 'Spanish' },
    { semantixId: '417', isoCode: 'es-UY', name: 'Spanish' },
    { semantixId: '90', isoCode: 'de-DE', name: 'German' },
    { semantixId: '347', isoCode: 'de-AT', name: 'German' },
    { semantixId: '407', isoCode: 'de-LU', name: 'German' },
    { semantixId: '284', isoCode: 'de-CH', name: 'German' },
    { semantixId: '112', isoCode: 'it-IT', name: 'Italian' },
    { semantixId: '288', isoCode: 'it-CH', name: 'Italian' },
    { semantixId: '6', isoCode: 'ar-EG', name: 'Arabic' },
    { semantixId: '333', isoCode: 'ar-IQ', name: 'Arabic' },
    { semantixId: '334', isoCode: 'ar-LB', name: 'Arabic' },
    { semantixId: '335', isoCode: 'ar-MA', name: 'Arabic' },
    { semantixId: '336', isoCode: 'ar-SA', name: 'Arabic' },
    { semantixId: '337', isoCode: 'ar-SY', name: 'Arabic' },
  ];

  // Swedish, Danish, Finnish, Norwegian (Bokmål), English, French, Spanish, German, Italian, Arabic

  var languages,
    languageTags = [],
    languageToTagify,
    subjects,
    $page = $('.translation-quote-page'),
    pardotTrackerUrlPath = 'l/848143/2022-09-05/4l1tbv';

  $(document).on(
    'click',
    ".quote-step[data-state='enabled'] [data-edit-step], .quote-step[data-state='valid'] [data-edit-step]",
    function () {
      var $me = $(this);
      var stepNum = $me.parents('.quote-step').data('step');
      $('.quote-step').removeClass('is-open');

      for (var i = stepNum + 1; i <= 4; i++) {
        $('.quote-step[data-step="' + i + '"]').attr('data-state', 'disabled');
      }
      $me.parents('.quote-step').addClass('is-open');
    }
  );

  $(document).on('click', 'a[data-history-back]', function () {
    history.back();
  });

  $(document).on(
    'click',
    ".quote-step[data-state='enabled'] [data-continue], .quote-step[data-state='valid'] [data-continue]",
    function () {
      var $me = $(this);
      var $step = $me.parents('.quote-step');
      var step_num = $step.data('step');

      if (isValidStep(step_num)) {
        $step.removeClass('is-open');
        $step.attr('data-state', 'valid');
        summarizeStep(step_num);
        nextStep(step_num);
      }
    }
  );

  $('input, select, textarea').on('focus', function () {
    $(this).addClass('has-interaction');
  }).on('blur', function () {
    $(this).trigger('change');
  });

  // TRANSLATION FILE UPLOAD
  const fileManager = {
    uploaded: [],
    queue: new DataTransfer()
  }
  
  const mediaFileManager = {
    uploaded: [],
    queue: new DataTransfer()
  }
  
  window.semantixFiles = fileManager
  window.semantixMedia = mediaFileManager
    
  $('#quote_file_upload').on('change', function (e) {
    onFileUploadChange(e, 'translation', fileManager, '#quote_file_upload')
  });

  $('#multimedia_file_upload').on('change', function (e) {
    onFileUploadChange(e, 'multimedia', mediaFileManager, '#multimedia_file_upload')
  });
  
  function onFileUploadChange(e, name, fManager, fileInput) {    
    const parentElem = `.file-upload-wrapper.${name}`
    // 1. Validate file with existing dataTransfer(fileManager.queue) files and uploaded ones
    if (!e.target.files || !e.target.files[0]) return;

    var max_file_size = 52428800 * 2; //100MB

    var nBytes = 0,
      files = e.target.files,
      nFiles = files.length;

    for (var nFileId = 0; nFileId < nFiles; nFileId++) {
      nBytes += files[nFileId].size;
    }

    if (nBytes > max_file_size) {
      alert('Max file size: ' + humanFileSize(max_file_size));
      this.value = '';
      return;
    }
    
    if ((parseInt(nFiles) + parseInt(fManager.queue.files.length) + parseInt(fManager.uploaded.length)) > 5) {
      alert('You are only allowed to upload a maximum of 5 files');
      this.value = '';
      return;
    }

    // Add files to queue
    let fileCount = 0
    for (let file of files) {
      file.id = (String(Date.now()) + fileCount);
      fManager.queue.items.add(file);
      fileCount++;
    }
    
    // Replace file
    e.target.files = fManager.queue.files;
    $('.files-preview', parentElem).find('.disposable').remove();
    // $('.file-upload-wrapper.translation .files-preview').empty();
  
    for(var i = 0; i < fManager.queue.files.length; i++){
      
      var f = fManager.queue.files[i];
      $('.files-preview', parentElem).append(
        $(
          "<div class='file-p disposable' data-status='queue' data-file-id='"+ f.id +"'><span class='name'>" +
            truncateString(f.name, 32) +
            "</span><span class='size'>" +
            humanFileSize(f.size) +
            '</span><span class="file-delete"><span>+</span></span></div>'
        )
      );
    };
   
    // Event listener for the created delete button
    $('span.file-delete', parentElem).click(function() {
      log('delete delete', $(this).parents('.file-p').data('file-id'))
      const id = $(this).parents('.file-p').data('file-id').toString();
      
      // Remove from preview list
      $(this).parent().remove();
      
      // Remove from the queue or the uploaded list
      if(fManager.uploaded.find((file) => file.id === id)) {
        fManager.uploaded = fManager.uploaded.filter((file) => file.id !== id)
      } else {
        for(let i = 0; i < fManager.queue.items.length; i++){
          // Match the file with the name
          if(id === fManager.queue.items[i].getAsFile().id){
            // Remove the file from the DataTransfer object
            fManager.queue.items.remove(i);
            continue;
          }
        }
      }
      
      // Update input file's files after deletion
      $(fileInput)[0].files = fManager.queue.files;
      $(fileInput).trigger('keyup')
    })

    const uploadButtonName = name === 'translation' ? 'a[data-upload-files]' : 'a[data-upload-multimedia]';
    if (e.target.files.length > 0) {
      $(uploadButtonName).removeClass('disabled');
    } else {
      $(uploadButtonName).addClass('disabled');
    }
  }

  $('a[data-upload-files]').on('click', function () {
    log('upload files click')
    $(this).addClass('disabled');
    $page.addClass('is-uploading');
    uploadFiles();
  });

  $('a[data-upload-multimedia]').on('click', function () {
    log('upload multimedia click')
    $(this).addClass('disabled');
    $page.addClass('is-uploading');
    uploadMultimediaFiles();
  });

  function onFileUploadError() {
    log('onFileUploadError')
    $page.removeClass('is-uploading');
  }

  function onFileUploadSuccess(data, name, fManager) {
    log('onFileUploadSuccess')
    const parentElem = `.file-upload-wrapper.${name}`
    $page.removeClass('is-uploading');
    log('File upload success:');
    log(data);
    var $file_p = $('.files-preview', parentElem);
    
    // Add finished queue items to uploaded and clear queue
    fManager.uploaded = [...fManager.uploaded, ...data.fileUrls.map((fileUrl, i) => Object({id: fManager.queue.files[i].id, url: fileUrl}))]
    fManager.queue.items.clear();
    
    let oldWordCount = $file_p.attr('data-word-count')
    let newWordCount = data.wordCount
    
    let wordCount
    
    // Only apply wordCount if it's the first upload
    if(oldWordCount === undefined) {
      wordCount = newWordCount
    } else {
      // Since we don't get a by-file word count, we need to send back a string
      wordCount = "Sorry, but we can't process your file."
    }
    
    $file_p.attr('data-word-count', wordCount);
    $file_p.attr('data-response-data', JSON.stringify(data));
    $('.files-preview .file-p', parentElem).removeClass('disposable').addClass('is-uploaded').data('status', 'uploaded');
    $('input[name="target_language"]', $file_p.parents('.quote-step')).trigger('change');
  }

  async function onStepDataChange(e) {
    log('onStepDataChange')
    var $me = $(e.target);
    var $step = $me.parents('.quote-step');
    var step_num = $step.data('step');

    const stepValid = await isValidStep(step_num) 
    
    if (stepValid) {
      $step.attr('data-state', 'valid');
    } else {
      $step.attr('data-state', 'enabled');
    }
  }

  $('input, select, textarea').on('change keyup', onStepDataChange);
  $('.accordion-title').on('click', onStepDataChange);
  // $('#service-type .tabs-title a').on('click', validateContent);

  $(document).on('click', '#service-type .tabs-title a', onStepDataChange);

  function isValidStep(current_step) {
    switch (current_step) {
      case 1:
        return validateContactInfo();
      case 2:
        return validateLanguage();
      case 3:
        return validateContent();
      case 4:
        return true;
      default:
    }
    return false;
  }

  // Validate Step 01
  async function validateContactInfo() {
    var is_valid = true;
    var $first_name = $('input[name="first_name"]'),
      $last_name = $('input[name="last_name"]'),
      $company = $('input[name="company"]'),
      $employees = $('select[name="employees"]'),
      $email = $('input[name="email"]'),
      $phone = $('input[name="phone"]');

    // first name
    if (getFirstName() == '') {
      if ($first_name.hasClass('has-interaction')) {
        $first_name.addClass('has-error');
      }
      is_valid = false;
    } else {
      $first_name.removeClass('has-error');
    }
    
    // last name
    if (getLastName() == '') {
      if ($last_name.hasClass('has-interaction')) {
        $last_name.addClass('has-error');
      }
      is_valid = false;
    } else {
      $last_name.removeClass('has-error');
    }
    
    // company
    if (getCompany() == '') {
      if ($company.hasClass('has-interaction')) {
        $company.addClass('has-error');
      }
      is_valid = false;
    } else {
      $company.removeClass('has-error');
    }
    
    // employees
    var employeesValue = getEmployees();
    if (employeesValue == '' || !employeesOptions.some(option => option.value === employeesValue)) {
      if ($employees.hasClass('has-interaction')) {
        $employees.addClass('has-error');
      }
      is_valid = false;
    } else {
      $employees.removeClass('has-error');
    }

    // email
    var email = getEmail();
    var hasInteraction = $email.hasClass('has-interaction');
      
    await validateEmail(email).then((result) => {

      if (result === 'validDomain') {
        $email.removeClass('has-error has-blacklist-error');
        return;
      }
      
      
      if (hasInteraction) { 
        var invalidResults = ['invalidString', 'blacklisted', 'invalidDomain']
        if (invalidResults.includes(result)) {
          $email.removeClass('has-blacklist-error');
          $email.addClass('has-error');
          
          is_valid = false;
        }
      }
    });
    
    // phone
    if (getPhone() == '') {
      if ($phone.hasClass('has-interaction')) {
        $phone.addClass('has-error');
      }
      is_valid = false;
    } else {
      $phone.removeClass('has-error');
    }
    
    return is_valid;
  }

  // Validate Step 02
  function validateLanguage() {
    var is_valid = true;
    isValidLangsForQuote();
    if (getToLang().length == 0) {
      is_valid = false;
    }

    return is_valid;
  }

  // Validate Step 03
  function validateContent() {
    var is_valid = true;

    var serviceType = getServiceType();

    log('ST: ' + serviceType);

    switch (serviceType) {
      case 'translation':
        is_valid = validateTranslation();
        break;
      case 'transcription':
        is_valid = validateTranscription();
        break;
      case 'subtitling':
        is_valid = validateSubtitling();
        break;
      case 'other':
        is_valid = validateOther();
        break;
      default:
        is_valid = false;
    }

    return is_valid;
  }

  // Validate Service type TRANSLATION
  function validateTranslation() {
    var calcType = getCalcType();
    var is_valid = true;

    if (calcType === null || calcType === undefined || calcType === '') {
      is_valid = false;
    }
    
    if (calcType === 'files') {
      if($('.file-upload-wrapper.translation .files-preview').find('.file-p.is-uploaded').length <= 0 || $('.file-upload-wrapper.translation .files-preview').find('.file-p.disposable').length > 0) {
        // Check uploaded files in div container
        is_valid = false;
      }
    } 
    
    if (calcType === 'words' && (getNumOfWords() <= 0 || getNumOfWords() === '')) {
      if ($('input[name="word-count"]').hasClass('has-interaction')) {
        $('input[name="word-count"]').addClass('has-error');
      }
      is_valid = false;
    } else {
      $('input[name="word-count"]').removeClass('has-error');
    }

    if (calcType === 'other' && $.trim($('textarea[name="i-need-help"]').val()) === '') {
      if ($('textarea[name="i-need-help"]').hasClass('has-interaction')) {
        $('textarea[name="i-need-help"]').addClass('has-error');
      }
      is_valid = false;
    } else {
      $('textarea[name="i-need-help"]').removeClass('has-error');
    }
    return is_valid;
  }

  // Validate Service type TRANSCRIPTION
  function validateTranscription() {
    var is_valid = true;
    var audio_length = getAudioLength();

    if (audio_length === null || audio_length === undefined || audio_length === '') {
      is_valid = false;
    }

    return is_valid;
  }

  // Validate Service type SUBTITLING
  function validateSubtitling() {
    var is_valid = true;
    var video_length = getVideoLength();

    if (video_length === null || video_length === undefined || video_length === '') {
      is_valid = false;
    }
    return is_valid;
  }

  // Validate Service type OTHER
  function validateOther() {
    var is_valid = true;
    // getOtherProjectDesc

    if ($.trim($('textarea[name="description-of-project"]').val()) === '') {
      if ($('textarea[name="description-of-project"]').hasClass('has-interaction')) {
        $('textarea[name="description-of-project"]').addClass('has-error');
      }
      is_valid = false;
    } else {
      $('textarea[name="description-of-project"]').removeClass('has-error');
    }
    return is_valid;
  }

  function summarizeStep(current_step) {
    switch (current_step) {
      case 1:
        $('.summary-row [data-full-name]').text(getFullName());
        $('.summary-row [data-company]').text(getCompany());
        $('.summary-row [data-employees]').text(getEmployees());
        $('.summary-row [data-email]').text(getEmail());
        $('.summary-row [data-phone]').text(getPhone());
        break;
      case 2:
        $('.summary-row [data-lang-from]').text(getFromLangName());
        $('.summary-row [data-lang-to]').text(getToLangName().join(', '));
        break;
      case 3:
        $('.summary-row [data-type-of-service]').text(getServiceTypeTitle());
        $('.summary-row [data-subject-area]').text(getSubjectArea() || '-');
        //$('.summary-row [data-calc-price-by]').text( getCalcTypeTitle() );
        $('.summary-row [data-translation-content]').text(getTranslationContent());
        break;
      case 4:
        // No summary only "content" state
        break;
      default:
    }
  }

  function nextStep(current_step) {
    var next_step = current_step + 1;
    var $next_step = $('.quote-step[data-step="' + next_step + '"]');

    if (next_step < 4) {
      $next_step.attr('data-state', 'enabled');
      $next_step.addClass('is-open');
      scrollToPos($next_step.offset().top - 150);
      $next_step.find('input').last().trigger('change');
    }

    var calc_delay = 3000;
    if (next_step === 4) {
      $page.addClass('is-calculating');
      calculatePrice();

      setTimeout(function () {
        $page.removeClass('is-calculating');
      }, calc_delay);

      setTimeout(function () {
        $next_step.attr('data-state', 'valid');
        $next_step.addClass('is-open');
        scrollToPos($next_step.offset().top - 150);
      }, calc_delay + 200);
    }

    if (next_step === 5) {
      $page.addClass('quote-submitted');
      scrollToPos(0);
    }

    updateLead(current_step);
  }

  function calculatePrice() {
    $('.contents-row [data-has-video]').hide();
    $('.contents-row [data-has-audio]').hide();
    $('.contents-row [data-has-other]').hide();
    $('.contents-row [data-has-translation]').hide();
    $('.contents-row [data-has-file-upload]').hide();
    $('.contents-row [data-no-price-translation]').hide();
    $('.contents-row [data-no-price-multimedia]').hide();

    switch (getServiceType()) {
      case 'translation':
        calculatePriceForTranslation();
        break;
      case 'transcription':
        calculatePriceForTranscription();
        break;
      case 'subtitling':
        calculatePriceForSubtitling();
        break;
      case 'other':
        calculatePriceForOther();
        break;
      default:
    }
  }

  function calculatePriceForTranslation() {
    var num_words = getNumOfWords(); // should handle files aswell
    var calcType = getCalcType();
    var num_langs = getToLang().length;
    var price, formatted_price;

    if (
      calcType === 'other' ||
      num_words > max_words_for_translation ||
      (calcType === 'files' && (isNaN(num_words) || num_words <= 0)) ||
      !isValidLangsForQuote()
    ) {
      // max 2000 words
      log('No price');
      price = 0;

      $('.contents-row [data-no-price]').show();
      $('.contents-row [data-has-price]').hide();
      $('.contents-row [data-no-price-translation]').show();
    } else {
      log('Has price');
      price = getPrice(num_words, num_langs) + '';
      formatted_price = price.replace('.', ',');
      $('[data-quote-price]').text(formatted_price);
      $('[data-quote-currency]').text(getCurrency());
      $('.contents-row [data-has-translation]').show();
      $('.contents-row [data-no-price]').hide();
      $('.contents-row [data-has-price]').show();
      // has price
    }
  }

  function calculatePriceForTranscription() {
    var price, formatted_price;
    price = getPriceForTranscription();

    $('.contents-row [data-has-audio]').show();
    $('.contents-row [data-has-file-upload]').show();

    if (price <= 0) {
      log('No price');
      price = 0;
      $('.contents-row [data-no-price]').show();
      $('.contents-row [data-has-price]').hide();
      $('.contents-row [data-no-price-multimedia]').show();
    } else {
      log('Has price');
      formatted_price = price.replace('.', ',');
      $('[data-quote-price]').text(formatted_price);
      $('[data-quote-currency]').text(getCurrency());

      $('.contents-row [data-no-price]').hide();
      $('.contents-row [data-has-price]').show();
    }
  }

  function calculatePriceForSubtitling() {
    var price, formatted_price;
    price = getPriceForSubtitling();

    $('.contents-row [data-has-video]').show();
    $('.contents-row [data-has-file-upload]').show();

    if (price <= 0) {
      log('No price');
      price = 0;
      $('.contents-row [data-no-price]').show();
      $('.contents-row [data-has-price]').hide();
      $('.contents-row [data-no-price-multimedia]').show();
    } else {
      log('Has price');
      formatted_price = price.replace('.', ',');
      $('[data-quote-price]').text(formatted_price);
      $('[data-quote-currency]').text(getCurrency());

      $('.contents-row [data-no-price]').hide();
      $('.contents-row [data-has-price]').show();
    }
  }

  function calculatePriceForOther() {
    // always no price
    $('.contents-row [data-no-price-multimedia]').show();
    $('.contents-row [data-no-price]').show();
    $('.contents-row [data-has-price]').hide();

    $('.contents-row [data-has-other]').show();
    $('.contents-row [data-has-file-upload]').show();
  }

  function isValidLangsForQuote() {
    var is_valid = true;
    var f_lang = getFromLang(); // string
    var t_lang = getToLang(); // array
    var sel_langs = [];
    sel_langs.push(parseInt(f_lang));

    for (var ii = 0; ii < t_lang.length; ii++) {
      sel_langs.push(t_lang[ii]);
    }

    for (var i = 0; i < sel_langs.length; i++) {
      //log('2: ' + sel_langs[i]);
      if (searchArr(_validLangsForTranslation, sel_langs[i], 'semantixId') === -1) {
        is_valid = false;
      }
    }

    log('is valid langs: ' + is_valid);
    //_validLangsForTranslation
    return is_valid;
  }

  function updateLead(step) {
    var leadData = buildLeadData(step);
    log('update lead in pardot');
    //log(leadData);
    callPardot(pardotTrackerUrlPath, leadData);
  }
  window.getServiceType = getServiceType
  window.getCalcType = getCalcType
  function buildLeadData(step) {
    var conv_url = window.document.referrer;

    if (conv_url === null || conv_url === undefined || conv_url === '') {
      conv_url = window.location.href;
    }

    var leadData = {
      email: getEmail(),
      first_name: getFirstName(),
      last_name: getLastName(),
      company: getCompany(),
      employees: getEmployees(),
      phone: getPhone(),
      country: getCountry(),
      conversion_URL: conv_url,
    };

    log('build lead for step ' + step);

    if (step === 2) {
      var fromLang = window.SMTX.iq.from_string + ': ' + getFromLangName() + '.';
      var toLang = window.SMTX.iq.to_string + ': ' + getToLangName().join(', ') + '.';
      leadData.translation_language = fromLang + ' ' + toLang;
    }

    if (step === 3) {
      leadData.Instant_Quote_Product_Interest = getServiceType();

      if (
        leadData.Instant_Quote_Product_Interest === 'transcription' ||
        leadData.Instant_Quote_Product_Interest === 'subtitling'
      ) {
        leadData.Instant_Quote_Product_Interest = 'multimedia';
      }
      // capitalize service type
      var capitalized = leadData.Instant_Quote_Product_Interest;
      capitalized = capitalized.charAt(0).toUpperCase() + capitalized.slice(1);
      leadData.Instant_Quote_Product_Interest = capitalized;

      leadData.Subject_area = getSubjectArea();

      if ($.trim(leadData.Subject_area) === '') {
        leadData.Subject_area = '-';
      }
      
      leadData.I_need_certified_translation_IQ = $('input#certified-translation').is(':checked')
      
      leadData.quote_price = 0;
      leadData.currency_IQ = '';
      leadData.tailored_solution = 'FALSE';

      var calcType = getCalcType();
      var word_count = getNumOfWords();
      var quote_price = getPrice(word_count, getToLang().length);
      var currency = getCurrency();

      if (calcType === 'files') {
        leadData.Description_of_translation = '-';
        leadData.word_count = word_count;
        
        if (word_count <= max_words_for_translation && isValidLangsForQuote() && word_count > 0) {
          leadData.quote_price = quote_price;
          leadData.currency_IQ = currency;
        } else {
          leadData.tailored_solution = 'TRUE';
          leadData.word_count = 0;
        }
      }

      if (calcType === 'words') {
        leadData.Description_of_translation = '-';
        leadData.word_count = word_count;
        if (word_count <= max_words_for_translation && isValidLangsForQuote()) {
          leadData.quote_price = quote_price;
          leadData.currency_IQ = currency;
        } else {
          leadData.tailored_solution = 'TRUE';
        }
      }

      if (calcType === 'other') {
        leadData.tailored_solution = 'TRUE';
        leadData.Description_of_translation = $.trim($page.find('textarea[name="i-need-help"]').val());
        leadData.word_count = 0;
      }

      switch (getServiceType()) {
        case 'translation':   
          // Generate list uf file urls
          if(fileManager.uploaded.length) {
            let linksList = '';
            for(let i = 0, il = fileManager.uploaded.length; i < il; i++) {
              if(i !== 0) {
                linksList += ', ';
              }
              linksList += fileManager.uploaded[i].url;
            }
            leadData.Link_to_content = linksList;
          } else {
            leadData.Link_to_content = '-';
          }
          break;
        case 'transcription':
          leadData.Description_of_translation = getAudioProjectDescription(); //"Transcription request, Audio file " + getAudioLengthTitle();
          leadData.quote_price = getPriceForTranscription();
          leadData.currency_IQ = currency;
          leadData.word_count = 0;
          leadData.Link_to_content = '-';
          break;
        case 'subtitling':
          leadData.Description_of_translation = getVideoProjectDescription(); //"Subtitling request, Video file " + getVideoLengthTitle();
          leadData.quote_price = getPriceForSubtitling();
          leadData.currency_IQ = currency;
          leadData.word_count = 0;
          leadData.Link_to_content = '-';
          break;
        case 'other':
          leadData.Description_of_translation = $.trim($('textarea[name="description-of-project"]').val());
          leadData.tailored_solution = 'TRUE';
          leadData.currency_IQ = currency;
          leadData.word_count = 0;
          leadData.Link_to_content = '-';
          break;
        default:
      }
      
      // If Multimedia files are uploaded, add the urls
      if (['transcription', 'subtitling', 'other'].indexOf(getServiceType()) > -1) {
        if(mediaFileManager.uploaded.length) {
          // Generate list uf file urls
          let linksList = '';
          for(let i = 0, il = mediaFileManager.uploaded.length; i < il; i++) {
            if(i !== 0) {
              linksList += ', ';
            }
            linksList += mediaFileManager.uploaded[i].url;
          }
          leadData.Link_to_content = linksList;
        } else {
          leadData.Link_to_content = '-';
        }
      }

      if (leadData.quote_price && parseInt(leadData.quote_price) === 0) {
        leadData.tailored_solution = 'TRUE';
      }
    } // end step 3

    var today = new Date();
    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

    if (step === 4) {
      leadData.GDPR_Newsletter = $('input[name="newsletter_signup"]').is(':checked') ? 'Yes' : '';
      leadData.comments = $.trim($page.find('textarea[name="quote_comment"]').val());
      leadData.Has_Ordered = 'TRUE';
      leadData.Has_ordered_IQ_date = date;
      leadData.order_Time_IQ = today.toLocaleTimeString();

      if (['transcription', 'subtitling', 'other'].indexOf(getServiceType()) > -1) {
        // If Multimedia files are uploaded, add the urls
        if(mediaFileManager.uploaded.length) {
          // Generate list uf file urls
          let linksList = '';
          for(let i = 0, il = mediaFileManager.uploaded.length; i < il; i++) {
            if(i !== 0) {
              linksList += ', ';
            }
            linksList += mediaFileManager.uploaded[i].url;
          }
          leadData.Link_to_content = linksList;
        } else {
          leadData.Link_to_content = '-';
        }
      }

      var iframeData = {
        email: getEmail(),
        first_name: getFirstName(),
        last_name: getLastName(),
        company: getCompany(),
        employees: getEmployees(),
        phone: getPhone(),
        country: getCountry(),
        conversion_URL: conv_url,
      };
      // <iframe src="http://www2.site.com/l/123/2009-04-28/ABCDE?first_name=John&last_name=Smith&email=john_smith@xyz.com&company=XYZ&phone=1234567890&zip=12345" width="1" height="1"></iframe>
      var qryStr = jQuery.param(iframeData);
      var iframeSrc = 'https://info.semantix-group.com/' + pardotTrackerUrlPath + '?' + qryStr;
      //log('iframesrc: ' + iframeSrc);

      $page.append($('<iframe src="' + iframeSrc + '" width="1" height="1"></iframe>'));
    }

    log(leadData);
    return leadData;
  }

  // form handler url
  //http://info.semantix-group.com/l/848143/2022-09-05/4l1tbv

  //   External Field Name	Prospect Field	Data Format	Required
  // email	Email	Email	Y
  // Has_Ordered	Has Ordered InstantQuote	Text
  // GDPR_Newsletter	GDPR Newsletter	Text
  // first_name	First Name	Text	Y
  // last_name	Last Name	Text	Y
  // company	Company	Text	Y
  // phone	Phone	Text	Y
  // comments	Comments	Text
  // country	Country	Text	Y
  // quote_price	Quote Price - IQ	Text
  // Link_to_content	Reference to translation content	Text
  // translation_language	Translation language	Text
  // tailored_solution	Tailored solution needed	Text
  // word_count	Word count	Text
  // Conversion URL	Conversion URL	Text
  // Description_of_translation	Description of translation project 	Text
  // Subject_area	Industry/subject area	Text

  function scrollToPos(pos) {
    var scrollEvents = 'scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove';
    // Reset animated scroll if it's already animating
    $('html, body').stop();
    $('html, body').off(scrollEvents);

    // Scroll to position $pos
    $('html, body').on(scrollEvents, function () {
      $('html, body').stop(); // Stop scrolling if we scroll while scrollTop is animating
    });

    $('html, body').animate({ scrollTop: pos }, 400, function () {
      $('html, body').off(scrollEvents);
    });
  }

  // tagify

  // Step1 Tagify - setup
  var tagifyOptions = {
    whitelist: [], // Is populated in languagesLoaded
    dropdown: {
      enabled: 0, // Shows dropdown instantly
      maxItems: 300, // Show all languages in dropdown
    },
    skipInvalid: true, // Don't show invalid tags
    delimiters: ';', // Comma causes issues, use semicolon instead
    remove: checkSelectedLanguages,
    add: checkSelectedLanguages,
  };

  languageToTagify = new Tagify($('input#to-language')[0], tagifyOptions);

  // Step1 Tagify - handlers
  $('select#from-language').on('change', checkSelectedLanguages);
  languageToTagify.on('add', checkSelectedLanguages);
  languageToTagify.on('remove', checkSelectedLanguages);
  languageToTagify.on('edit', checkSelectedLanguages);
  languageToTagify.on('blur', checkSelectedLanguages);

  function checkSelectedLanguages() {
    //trigger change
    $('input[name="to-language"]').trigger('change');
  }

  function callPardot(formHandler, data) {
    var formUrl = '/pardot/form_handler.php?path=' + formHandler;
    // formUrl = 'l/848143/2022-09-05/4l1tbv';
    $.ajax({
      method: 'POST',
      timeout: 0,
      url: formUrl,
      data: data,
      success: onFormSuccess,
      error: onFormError,
    });
  }

  function onFormSuccess(response) {
    log('Success' + response);
  }
  function onFormError(response) {
    log('Error' + response);
  }

  var wordCountUrl = 'https://stg-glese.transperfect.com/api/iq/wordcounts';

  function uploadFiles() {
    // var token = "1|NPcdXwiYX7EwOgyrQtlfhD6GxfRzUeVtteVqyrDs";
    var token = 'i3EjtpcJIALtSr9UfJNVtIcnMjSDCFUzynlEA51bATBnLRHmmyIaNoxN1jiuaaO6';
    var formData = new FormData($('#upload_file_form')[0]);

    $.ajax({
      url: wordCountUrl,
      type: 'POST',
      headers: { Authorization: 'Bearer ' + token },
      data: formData,
      dataType: 'JSON',
      processData: false,
      contentType: false,
      error: onFileUploadError,
      success: function(data) {
        onFileUploadSuccess(data, 'translation', fileManager)
      },
    });
  }

  function uploadMultimediaFiles() {
    // var token = "1|NPcdXwiYX7EwOgyrQtlfhD6GxfRzUeVtteVqyrDs";
    var token = 'i3EjtpcJIALtSr9UfJNVtIcnMjSDCFUzynlEA51bATBnLRHmmyIaNoxN1jiuaaO6';
    var formData = new FormData($('#upload_multimedia_file')[0]);

    $.ajax({
      url: wordCountUrl,
      type: 'POST',
      headers: { Authorization: 'Bearer ' + token },
      data: formData,
      dataType: 'JSON',
      processData: false,
      contentType: false,
      error: onFileUploadError,
      success: function(data) {
        onFileUploadSuccess(data, 'multimedia', mediaFileManager)
      },
    });
  }

  function serializeForm($form) {
    var form = $form,
      formData = new FormData(),
      formParams = form.serializeArray();

    $.each(form.find('input[type="file"]'), function (i, tag) {
      $.each($(tag)[0].files, function (i, file) {
        formData.append(tag.name, file);
      });
    });

    $.each(formParams, function (i, val) {
      formData.append(val.name, val.value);
    });

    return formData;
  }

  /*********************************

  Lead data getters

*********************************/

  function getFullName() {
    return getFirstName() + ' ' + getLastName();
  }

  function getFirstName() {
    return $.trim($page.find('input[name="first_name"]').val());
  }

  function getLastName() {
    return $.trim($page.find('input[name="last_name"]').val());
  }

  function getCompany() {
    return $.trim($page.find('input[name="company"]').val());
  }

  function getEmployees() {
    return $page.find('select[name="employees"] option:selected').val();
  }
  
  function getEmail() {
    return $.trim($page.find('input[name="email"]').val()).toLowerCase();
  }

  function getPhone() {
    return $.trim($page.find('input[name="phone"]').val());
  }

  function getFromLang() {
    return $page.find('select[name="from-language"]').val();
  }

  function getFromLangName() {
    return $page.find('select[name="from-language"] option:selected').text();
  }

  function getFromLangCode() {
    return $page.find('select[name="from-language"] option:selected').data('code');
  }

  function getToLang() {
    var toLang = [];
    // Format language tags
    for (var i = 0, il = languageToTagify.value.length; i < il; i++) {
      //log("From: " + quoteLead.fromLang + ", To: " + languageToTagify.value[i].id);
      toLang.push(languageToTagify.value[i].id);
    }
    return toLang;
  }

  function getToLangName() {
    var toLang = [];
    // Format language tags
    for (var i = 0, il = languageToTagify.value.length; i < il; i++) {
      //log("From: " + quoteLead.fromLang + ", To: " + languageToTagify.value[i].id);
      toLang.push(languageToTagify.value[i].value);
    }
    return toLang;
  }

  function getToLangCode() {
    var toLang = [];
    // Format language tags
    for (var i = 0, il = languageToTagify.value.length; i < il; i++) {
      //log("From: " + quoteLead.fromLang + ", To: " + languageToTagify.value[i].id);
      toLang.push(languageToTagify.value[i].code);
    }
    return toLang;
  }

  function getSubjectArea() {
    return $.trim($page.find('input[name="quote-subject"]').val()) || '-';
  }

  function getAudioLength() {
    return $.trim($page.find('#iq_transcription .accordion-item.is-active').attr('data-audio-length'));
  }

  function getAudioLengthTitle() {
    return $page.find('#iq_transcription .accordion-item.is-active [data-audio-length-title]').text() || null;
  }

  function getAudioLengthDesc() {
    return $page.find('#iq_transcription .accordion-item.is-active [data-audio-length-desc]').text() || null;
  }

  function getAudioProjectDescription() {
    var str = getServiceTypeTitle() + ' ' + getAudioLengthTitle() + ' (' + getAudioLengthDesc().toLowerCase() + ')';
    // E.g."Transcription 1-5 minutes ( Audio file length 1-5 minutes );
    return str;
  }

  function getVideoLength() {
    return $.trim($page.find('#iq_subtitling .accordion-item.is-active').attr('data-video-length'));
  }

  function getVideoLengthTitle() {
    return $page.find('#iq_subtitling .accordion-item.is-active [data-video-length-title]').text() || null;
  }
  function getVideoLengthDesc() {
    return $page.find('#iq_subtitling .accordion-item.is-active [data-video-length-desc]').text() || null;
  }

  function getVideoProjectDescription() {
    var str = getServiceTypeTitle() + ' ' + getVideoLengthTitle() + ' (' + getVideoLengthDesc().toLowerCase() + ')';
    // E.g."Subtitling 1-5 minutes ( Video length 1-5 minutes )
    return str;
  }

  function getOtherProjectDesc() {
    return $.trim($page.find('#iq_other textarea').val());
  }

  function getCalcTypeTitle() {
    return $page.find('#iq_translation .accordion-item.is-active [data-calc-type-title]').text() || null;
  }

  function getServiceType() {
    return $page.find('#service-type .tabs-title.is-active').data('service-type') || null;
  }

  function getServiceTypeTitle() {
    return $page.find('#service-type .tabs-title.is-active a').text() || null;
  }

  function getCalcType() {
    return $page.find('#iq_translation .accordion-item.is-active').data('calc-type') || null;
  }

  function getNumOfWords() {
    var wc = '';
    var calcType = $page.find('#iq_translation .accordion-item.is-active').attr('data-calc-type');
    switch (calcType) {
      case 'files':
        var $file_p = $('.file-upload-wrapper.translation .files-preview');
        wc = isNaN($file_p.attr('data-word-count')) ? '' : parseInt($file_p.attr('data-word-count'));
        break;
      case 'words':
        wc = $.trim($page.find('input[name="word-count"]').val());
        break;
      case 'other':
        wc = '';
        break;
      default:
    }
    return wc;
  }

  function getTranslationContent() {
    var translation_content = '';
    var serviceType = getServiceType();

    if (serviceType === 'translation') {
      var calcType = $page.find('#iq_translation .accordion-item.is-active').attr('data-calc-type');
      switch (calcType) {
        case 'files':
          translation_content = getNumOfWords() > 0 ? getNumOfWords() + ' ' + window.SMTX.iq.words_string : '';
          break;
        case 'words':
          translation_content = $page.find('input[name="word-count"]').val() + ' ' + window.SMTX.iq.words_string;
          break;
        case 'other':
          translation_content = $.trim($page.find('textarea[name="i-need-help"]').val());
          break;
        default:
      }
    } else if (serviceType === 'transcription') {
      translation_content = getAudioLengthDesc() || '-'; //$page.find('#iq_transcription .accordion-item.is-active [data-audio-length-title]').text();
    } else if (serviceType === 'subtitling') {
      translation_content = getVideoLengthDesc() || '-'; //$page.find('#iq_subtitling .accordion-item.is-active [data-video-length-title]').text();
    } else {
      translation_content = $.trim(getOtherProjectDesc());
    }
    return translation_content;
  }

  function getPrice(num_words, num_langs) {
    num_words = Math.max(num_words, 380);

    var price = 0;
    switch (window.SMTX.iq.country_code) {
      case 'GB':
        price = (0.25 * num_words + 80 / 2) * num_langs;
        break;
      case 'SE':
        price = (2.9 * num_words + 800 / 2) * num_langs;
        break;
      case 'NO':
        price = (2.9 * num_words + 800 / 2) * num_langs;
        break;
      case 'DK':
        price = (1.8 * num_words + 560 / 2) * num_langs;
        break;
      case 'FI':
        price = (0.25 * num_words + 80 / 2) * num_langs;
        break;
      default:
        price = 0;
    }

    log('num_words: ' + num_words);

    if (num_words === 0 || isNaN(num_words) || num_words === '') {
      price = 0;
    }
    //Total Price = WordCount* perWordPrice + perHourPmRate/2*CountLanguageCombinations
    // SEK: 2,50 SEK/word + ½ hour Project Management at 800 SEK/h per language combination
    return price.toFixed(2);
  }

  function getPriceForTranscription() {
    var price = 0;
    var from_lang = getFromLangCode();
    var to_lang = getToLangCode();

    if (to_lang.length > 1) {
      // max 1 lang for price
      price = 0;
      return price.toFixed(2);
    }

    to_lang = to_lang[0] + '';

    var priceTable = [
      { from: 'sv-SE', to: 'sv-SE' },
      { from: 'da-DK', to: 'da-DK' },
      { from: 'fi-FI', to: 'fi-FI' },
      { from: 'en-GB', to: 'en-GB' },
      { from: 'en-US', to: 'en-US' },
    ];

    var has_price = false;

    for (var i = 0; i < priceTable.length; i++) {
      if (priceTable[i].from === from_lang && priceTable[i].to === to_lang) {
        has_price = true;
        break;
      }
    }

    if (!has_price || getAudioLength() === '>5') {
      price = 0;
      return price.toFixed(2);
    }

    switch (window.SMTX.iq.country_code) {
      case 'GB':
        price = 95;
        break;
      case 'SE':
        price = 950;
        break;
      case 'NO':
        price = 990;
        break;
      case 'DK':
        price = 975;
        break;
      case 'FI':
        price = 95;
        break;
      default:
        price = 0;
    }

    return price.toFixed(2);
  }

  function getPriceForSubtitling() {
    var price = 0;
    var from_lang = getFromLangCode();
    var to_lang = getToLangCode();
    var priceGroup = false;
    var subtitling_length_index = parseInt(
      $page.find('#iq_subtitling .accordion-item.is-active').attr('data-length-index')
    ); // price array index for selected video length

    if (to_lang.length > 1 || subtitling_length_index < 0) {
      // max 1 lang for price, selected length must have price index >= 0
      price = 0;
      return price.toFixed(2);
    }

    to_lang = to_lang[0] + '';

    var priceTable = [
      // Price group 1
      { from: 'sv-SE', to: 'sv-SE', priceGroup: 1 },
      { from: 'da-DK', to: 'da-DK', priceGroup: 1 },
      { from: 'fi-FI', to: 'fi-FI', priceGroup: 1 },
      { from: 'en-GB', to: 'en-GB', priceGroup: 1 },
      { from: 'en-US', to: 'en-US', priceGroup: 1 },

      // Price group 2
      { from: 'nb-NO', to: 'nb-NO', priceGroup: 2 },

      // Price group 3
      { from: 'sv-SE', to: 'fi-FI', priceGroup: 3 },
      { from: 'sv-SE', to: 'en-US', priceGroup: 3 },
      { from: 'sv-SE', to: 'en-GB', priceGroup: 3 },

      { from: 'da-DK', to: 'en-US', priceGroup: 3 },
      { from: 'da-DK', to: 'en-GB', priceGroup: 3 },

      { from: 'fi-FI', to: 'sv-SE', priceGroup: 3 },
      { from: 'fi-FI', to: 'en-US', priceGroup: 3 },
      { from: 'fi-FI', to: 'en-GB', priceGroup: 3 },

      { from: 'en-US', to: 'sv-SE', priceGroup: 3 },
      { from: 'en-US', to: 'da-DK', priceGroup: 3 },
      { from: 'en-US', to: 'fi-FI', priceGroup: 3 },

      { from: 'en-GB', to: 'sv-SE', priceGroup: 3 },
      { from: 'en-GB', to: 'da-DK', priceGroup: 3 },
      { from: 'en-GB', to: 'fi-FI', priceGroup: 3 },

      // Price group 4
      { from: 'nb-NO', to: 'en-GB', priceGroup: 4 },
      { from: 'nb-NO', to: 'en-US', priceGroup: 4 },
      { from: 'en-GB', to: 'nb-NO', priceGroup: 4 },
      { from: 'en-US', to: 'nb-NO', priceGroup: 4 },
    ];

    //{priceGroup: 1, sek: [5 min, 10 min, 15 min], eur: [5 min, 10 min, 15 min], nok:[5 min, 10 min, 15 min], dkk: [5 min, 10 min, 15 min]},
    var priceGroupTable = [
      { priceGroup: 1, sek: [1250, 2000, 2250], eur: [120, 180, 205], nok: [1250, 2000, 2250], dkk: [950, 1350, 1525] },
      {
        priceGroup: 2,
        sek: [1350, 2200, 2700],
        eur: [125, 200, 240],
        nok: [1350, 2200, 2700],
        dkk: [1020, 1800, 1800],
      },
      {
        priceGroup: 3,
        sek: [1500, 2500, 3300],
        eur: [140, 230, 300],
        nok: [1500, 2500, 3300],
        dkk: [1020, 1700, 2230],
      },
      {
        priceGroup: 4,
        sek: [1500, 2900, 4200],
        eur: [140, 260, 380],
        nok: [1500, 2900, 4200],
        dkk: [1020, 2000, 2840],
      },
    ];

    var has_price = false;

    for (var i = 0; i < priceTable.length; i++) {
      if (priceTable[i].from === from_lang && priceTable[i].to === to_lang) {
        has_price = true;
        priceGroup = priceTable[i].priceGroup;
        break;
      }
    }

    if (!has_price || !priceGroup) {
      price = 0;
      return price.toFixed(2);
    }

    //get price from price group table
    switch (window.SMTX.iq.country_code) {
      case 'GB':
        price = priceGroupTable[priceGroup - 1].eur[subtitling_length_index];
        break;
      case 'SE':
        price = priceGroupTable[priceGroup - 1].sek[subtitling_length_index];
        break;
      case 'NO':
        price = priceGroupTable[priceGroup - 1].nok[subtitling_length_index];
        break;
      case 'DK':
        price = priceGroupTable[priceGroup - 1].dkk[subtitling_length_index];
        break;
      case 'FI':
        price = priceGroupTable[priceGroup - 1].eur[subtitling_length_index];
        break;
      default:
        price = 0;
    }

    return price.toFixed(2);
  }


  /*********************************

  Init functions

*********************************/

  function loadLanguages() {
    // load languages
    $.get('/static/json/languages_' + window.SMTX.iq.country_code + '.json', {}, function (e) {
      languages = e;

      languages = languages.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
      });

      // Populate to select box
      $('select#from-language').html('');

      // Loop all languages
      for (var i = 0, il = languages.length; i < il; i++) {
        // Create language nodes
        $('select#from-language').append(
          '<option value="' +
            languages[i].id +
            '"' +
            // Check Swedish by default if no module language data exists, otherwise select the correct from-language
            (languages[i].id == window.SMTX.iq.default_from_lang_id ? ' selected="selected"' : '') +
            ' data-code="' +
            languages[i].code +
            '">' + // Preselect Swedish
            languages[i].name + // Name visible in dropdown
            '</option>'
        );

        // Setup to-language - Populate languageTags with correct format
        if (languages[i].id == window.SMTX.iq.default_from_lang_id + '9999') {
          // avtive lang?
        } else {
          languageTags.push({
            code: languages[i].code,
            id: languages[i].id,
            name: languages[i].name, // Keep original naming in case other value is used
            value: languages[i].name,
          });
        }
      }

      // Add language tags to tagify
      languageToTagify.settings.whitelist = languageTags;
      languageToTagify.settings.enforceWhitelist = true; // Only allow language tags, no text-tags
    });
  }
  
  function loadEmployees() {
    var initialOption = { value: '', text: window.SMTX.iq.employees_placeholder };
    var $employees = $('select#employees');
    
    $employees.html('');
    
    $employees.append(
      $('<option>', {
        value: initialOption.value,
        text: initialOption.text,
        disabled: true,
        selected: true,
      })
    );
    
    for (var i = 0; i < employeesOptions.length; i++) {
      $employees.append(
        $('<option>', {
          value: employeesOptions[i].value,
          text: employeesOptions[i].text,
        })
      );
    }
  }

  loadEmployees();
  loadLanguages();

  return {};
})();
